import { createAnalyticsEvent } from 'analytics/create-analytics-event';
import { GAEventName } from 'analytics/ga-event-name.enum';

export const digitPressEvent = createAnalyticsEvent<{
  digit: string;
  phoneNumber: string;
}>(({ digit, phoneNumber }) => ({
  event: GAEventName.DIGIT_PRESS,
  digit,
  phone_number: phoneNumber
}));

export const callStartedEvent = createAnalyticsEvent<{
  phoneNumber: string;
}>(({ phoneNumber }) => ({
  event: GAEventName.CALL_STARTED,
  phone_number: phoneNumber
}));

export const ctaClickEvent = createAnalyticsEvent<{
  dest: string;
}>(({ dest }) => ({
  event: GAEventName.CTA_CLICK,
  dest
}));

export const callEndEvent = createAnalyticsEvent<{
  phoneNumber: string;
}>(({ phoneNumber }) => ({
  event: GAEventName.CALL_END,
  phone_number: phoneNumber
}));

export const clipStartEvent = createAnalyticsEvent(() => ({
  event: GAEventName.CLIP_START
}));
